function loadInternship(view) {
    return () => import( /* webpackChunkName: "internships-[request]" */ `../components/Internships/${view}.vue`)
}
function loadViewInternship(view) {
    return () => import( /* webpackChunkName: "internships-[request]" */ `../views/Internship/${view}.vue`)
}
function loadInternshipExam(view) {
    return () => import( /* webpackChunkName: "internships-[request]" */ `../components/InternshipExam/${view}.vue`)
}
function loadTranscript(view) {
    return () => import( /* webpackChunkName: "internships-[request]" */ `../components/Transcript/${view}.vue`)
}
const internshipRoute = [
    {
        path: '/:internshipType(internship|praktical-work)',
        name: 'Pendaftaran KP/Magang',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadInternship('RegistrationView')
    },
    {
        path: '/internship-verify/:internshipType(internship|praktical-work)',
        name: 'Verifikasi KP/Magang',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen','kadep','wadek','kalab']
        },
        component: loadInternship('VerifyRegistration')
    },
    {
        path: '/internship-rejection/:internshipType(internship|praktical-work)',
        name: 'Ajuan Penolakan',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInternship('VerifyRejection')
    },
    {
        path: '/internship-change-date/:internshipType(internship|praktical-work)',
        name: 'Ajuan Perubahan Tanggal',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInternship('VerifyChangeDate')
    },
    {
        path: '/internship-letter-cq/:internshipType(internship|praktical-work)',
        name: 'Ajuan Penambahan CQ',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInternship('VerifyLetterCq')
    },
    {
        path: '/internship-rejection/:internshipType(internship|praktical-work)/:id',
        name: 'Rejection',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadInternship('RejectionView')
    },
    {
        path: '/internship-change-date/:internshipType(internship|praktical-work)/:id',
        name: 'ChangeDate',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadInternship('ChangeDateView')
    },
    {
        path: '/internship-letter-cq/:internshipType(internship|praktical-work)/:id',
        name: 'LetterCQ',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa','wadek','kalab','dosen','kadep','kaprodi','sekprodi']
        },
        component: loadInternship('LetterCqView')
    },
    {
        path: '/internship-exam/:internshipType(internship|praktical-work)',
        name: 'Verifikasi Ujian Kp/Magang',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen','kadep','wadek','kalab'],
        },
        component: loadInternship('VerifyExam')
    },
    {
        path: '/internship-exam/:internshipType(internship|praktical-work)/:internshipId',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadInternshipExam('MainView'),
        children: [
            {
                path: '',
                name: 'Ujian KP/Magang',
                component: loadInternshipExam('ExamDetail'),
            },
            {
                path: 'company',
                name: 'Penilaian Perusahaan KP/Magang',
                component: loadInternshipExam('CompanyRubric'),
            },
            {
                path: 'lecture',
                name: 'Penilaian Dosen KP/Magang',
                component: loadInternshipExam('LectureRubric'),
            },
            {
                path: 'tester',
                name: 'Penilaian Dosen Penguji KP/Magang',
                component: loadInternshipExam('TesterRubric'),
            },
            {
                path: 'result',
                name: 'Nilai KP/Magang',
                component: loadInternshipExam('InternshipResult'),
            },
            {
                path: 'spp/:npm',
                name: 'KP/Magang SPP',
                component: loadTranscript('SPP'),
            },
        ]
    },
    {
        path: '/:internshipType(internship|praktical-work)/internship-logbook/:internships_id',
        name: 'Logbook',
        meta: {
        requiresAuth: true,
        roleVerif: false,
        role: []
        },
        component: loadInternship('LogBook')
    },
    {
        path: '/internship-rubric/:internshipType(internship|praktical-work)',
        name: 'InternshipRubricCategory',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadInternship('RubricCategory')
    },
    {
        path: '/internship-rubric/:internshipType(internship|praktical-work)/:categoryId',
        name: 'InternshipRubricField',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadInternship('RubricField')
    },
    {
        path: '/internship-types',
        name: 'InternshipType',
        meta: {
        requiresAuth: true,
        roleVerif: true,
        role: ['kaprodi','sekprodi']
        },
        component: loadViewInternship('InternshipType')
    },
]

export default internshipRoute